export default __webpack_public_path__ + "static/media/ava-01.53d4b552.png";